/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as PublicRouteImport } from './routes/_public';
import { Route as AuthRouteImport } from './routes/_auth';
import { Route as IndexRouteImport } from './routes/index';
import { Route as PublicLoginRouteImport } from './routes/_public/login';
import { Route as AuthVisitMonitorRouteImport } from './routes/_auth/visit-monitor';
import { Route as AuthVisitListRouteImport } from './routes/_auth/visit-list';
import { Route as AuthTranslationsV2RouteImport } from './routes/_auth/translations-v2';
import { Route as AuthPhotoViewerRouteImport } from './routes/_auth/photo-viewer';
import { Route as AuthHomeRouteImport } from './routes/_auth/home';
import { Route as AuthDocumentsV2RouteImport } from './routes/_auth/documents-v2';
import { Route as AuthUsersRightsIndexRouteImport } from './routes/_auth/users-rights.index';
import { Route as AuthUsersRightsUserIdRouteImport } from './routes/_auth/users-rights.$userId';
import { Route as AuthDictionariesKindRouteImport } from './routes/_auth/dictionaries.$kind';

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any);
const AuthVisitMonitorRoute = AuthVisitMonitorRouteImport.update({
  id: '/visit-monitor',
  path: '/visit-monitor',
  getParentRoute: () => AuthRoute,
} as any);
const AuthVisitListRoute = AuthVisitListRouteImport.update({
  id: '/visit-list',
  path: '/visit-list',
  getParentRoute: () => AuthRoute,
} as any);
const AuthTranslationsV2Route = AuthTranslationsV2RouteImport.update({
  id: '/translations-v2',
  path: '/translations-v2',
  getParentRoute: () => AuthRoute,
} as any);
const AuthPhotoViewerRoute = AuthPhotoViewerRouteImport.update({
  id: '/photo-viewer',
  path: '/photo-viewer',
  getParentRoute: () => AuthRoute,
} as any);
const AuthHomeRoute = AuthHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthRoute,
} as any);
const AuthDocumentsV2Route = AuthDocumentsV2RouteImport.update({
  id: '/documents-v2',
  path: '/documents-v2',
  getParentRoute: () => AuthRoute,
} as any);
const AuthUsersRightsIndexRoute = AuthUsersRightsIndexRouteImport.update({
  id: '/users-rights/',
  path: '/users-rights/',
  getParentRoute: () => AuthRoute,
} as any);
const AuthUsersRightsUserIdRoute = AuthUsersRightsUserIdRouteImport.update({
  id: '/users-rights/$userId',
  path: '/users-rights/$userId',
  getParentRoute: () => AuthRoute,
} as any);
const AuthDictionariesKindRoute = AuthDictionariesKindRouteImport.update({
  id: '/dictionaries/$kind',
  path: '/dictionaries/$kind',
  getParentRoute: () => AuthRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/documents-v2': typeof AuthDocumentsV2Route;
  '/home': typeof AuthHomeRoute;
  '/photo-viewer': typeof AuthPhotoViewerRoute;
  '/translations-v2': typeof AuthTranslationsV2Route;
  '/visit-list': typeof AuthVisitListRoute;
  '/visit-monitor': typeof AuthVisitMonitorRoute;
  '/login': typeof PublicLoginRoute;
  '/dictionaries/$kind': typeof AuthDictionariesKindRoute;
  '/users-rights/$userId': typeof AuthUsersRightsUserIdRoute;
  '/users-rights/': typeof AuthUsersRightsIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/documents-v2': typeof AuthDocumentsV2Route;
  '/home': typeof AuthHomeRoute;
  '/photo-viewer': typeof AuthPhotoViewerRoute;
  '/translations-v2': typeof AuthTranslationsV2Route;
  '/visit-list': typeof AuthVisitListRoute;
  '/visit-monitor': typeof AuthVisitMonitorRoute;
  '/login': typeof PublicLoginRoute;
  '/dictionaries/$kind': typeof AuthDictionariesKindRoute;
  '/users-rights/$userId': typeof AuthUsersRightsUserIdRoute;
  '/users-rights': typeof AuthUsersRightsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/_auth': typeof AuthRouteWithChildren;
  '/_public': typeof PublicRouteWithChildren;
  '/_auth/documents-v2': typeof AuthDocumentsV2Route;
  '/_auth/home': typeof AuthHomeRoute;
  '/_auth/photo-viewer': typeof AuthPhotoViewerRoute;
  '/_auth/translations-v2': typeof AuthTranslationsV2Route;
  '/_auth/visit-list': typeof AuthVisitListRoute;
  '/_auth/visit-monitor': typeof AuthVisitMonitorRoute;
  '/_public/login': typeof PublicLoginRoute;
  '/_auth/dictionaries/$kind': typeof AuthDictionariesKindRoute;
  '/_auth/users-rights/$userId': typeof AuthUsersRightsUserIdRoute;
  '/_auth/users-rights/': typeof AuthUsersRightsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/documents-v2'
    | '/home'
    | '/photo-viewer'
    | '/translations-v2'
    | '/visit-list'
    | '/visit-monitor'
    | '/login'
    | '/dictionaries/$kind'
    | '/users-rights/$userId'
    | '/users-rights/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/documents-v2'
    | '/home'
    | '/photo-viewer'
    | '/translations-v2'
    | '/visit-list'
    | '/visit-monitor'
    | '/login'
    | '/dictionaries/$kind'
    | '/users-rights/$userId'
    | '/users-rights';
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_public'
    | '/_auth/documents-v2'
    | '/_auth/home'
    | '/_auth/photo-viewer'
    | '/_auth/translations-v2'
    | '/_auth/visit-list'
    | '/_auth/visit-monitor'
    | '/_public/login'
    | '/_auth/dictionaries/$kind'
    | '/_auth/users-rights/$userId'
    | '/_auth/users-rights/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthRoute: typeof AuthRouteWithChildren;
  PublicRoute: typeof PublicRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof PublicRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_auth': {
      id: '/_auth';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_public/login': {
      id: '/_public/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof PublicLoginRouteImport;
      parentRoute: typeof PublicRoute;
    };
    '/_auth/visit-monitor': {
      id: '/_auth/visit-monitor';
      path: '/visit-monitor';
      fullPath: '/visit-monitor';
      preLoaderRoute: typeof AuthVisitMonitorRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/visit-list': {
      id: '/_auth/visit-list';
      path: '/visit-list';
      fullPath: '/visit-list';
      preLoaderRoute: typeof AuthVisitListRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/translations-v2': {
      id: '/_auth/translations-v2';
      path: '/translations-v2';
      fullPath: '/translations-v2';
      preLoaderRoute: typeof AuthTranslationsV2RouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/photo-viewer': {
      id: '/_auth/photo-viewer';
      path: '/photo-viewer';
      fullPath: '/photo-viewer';
      preLoaderRoute: typeof AuthPhotoViewerRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/home': {
      id: '/_auth/home';
      path: '/home';
      fullPath: '/home';
      preLoaderRoute: typeof AuthHomeRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/documents-v2': {
      id: '/_auth/documents-v2';
      path: '/documents-v2';
      fullPath: '/documents-v2';
      preLoaderRoute: typeof AuthDocumentsV2RouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/users-rights/': {
      id: '/_auth/users-rights/';
      path: '/users-rights';
      fullPath: '/users-rights/';
      preLoaderRoute: typeof AuthUsersRightsIndexRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/users-rights/$userId': {
      id: '/_auth/users-rights/$userId';
      path: '/users-rights/$userId';
      fullPath: '/users-rights/$userId';
      preLoaderRoute: typeof AuthUsersRightsUserIdRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/dictionaries/$kind': {
      id: '/_auth/dictionaries/$kind';
      path: '/dictionaries/$kind';
      fullPath: '/dictionaries/$kind';
      preLoaderRoute: typeof AuthDictionariesKindRouteImport;
      parentRoute: typeof AuthRoute;
    };
  }
}

interface AuthRouteChildren {
  AuthDocumentsV2Route: typeof AuthDocumentsV2Route;
  AuthHomeRoute: typeof AuthHomeRoute;
  AuthPhotoViewerRoute: typeof AuthPhotoViewerRoute;
  AuthTranslationsV2Route: typeof AuthTranslationsV2Route;
  AuthVisitListRoute: typeof AuthVisitListRoute;
  AuthVisitMonitorRoute: typeof AuthVisitMonitorRoute;
  AuthDictionariesKindRoute: typeof AuthDictionariesKindRoute;
  AuthUsersRightsUserIdRoute: typeof AuthUsersRightsUserIdRoute;
  AuthUsersRightsIndexRoute: typeof AuthUsersRightsIndexRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDocumentsV2Route: AuthDocumentsV2Route,
  AuthHomeRoute: AuthHomeRoute,
  AuthPhotoViewerRoute: AuthPhotoViewerRoute,
  AuthTranslationsV2Route: AuthTranslationsV2Route,
  AuthVisitListRoute: AuthVisitListRoute,
  AuthVisitMonitorRoute: AuthVisitMonitorRoute,
  AuthDictionariesKindRoute: AuthDictionariesKindRoute,
  AuthUsersRightsUserIdRoute: AuthUsersRightsUserIdRoute,
  AuthUsersRightsIndexRoute: AuthUsersRightsIndexRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute;
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
};

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
